import styled from "styled-components";


export const CardsContainer = styled.div`
  .MuiPaper-root {
    box-shadow: none !important;
  }

  .MuiAccordion-root::before {
    background-color: #fff !important;
  }

  .MuiAccordionDetails-root {
    padding: 0 !important;
  }

  .MuiAccordionSummary-content {
    margin: 0 !important;
  }

  .MuiButtonBase-root {
    min-height: 0 !important;
  }
`;

export const ExpansiveCardContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 3px 15px;
  border-bottom: 1px solid #E5E4E5;
  width: 100%;

  .installment-title {
    color: #1A191A;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
  }

  span {
    text-align: center;
    width: fit-content;
  }

  .installment-icon, .expand-icon {
    color: #F58220;
  }

  .installment-icon {
    font-size: 22px;
  }

  .expand-icon {
    font-size: 16px; 
  }
`;

export const InstallmentOption = styled.div`
  cursor: pointer;
  border-bottom: 1px solid #E5E4E5;

  :hover {
    opacity: 0.95;
    background-color: #005FAE;
    div {
      color: #fff !important;
    }
  }

  .option {
    padding: 10px;
    display: flex;
    align-items: center;
    gap: 12px;

    div {
      display: flex;
      flex-direction: column;
      color: #005FAE;

      span, strong {
        font-size: 14px;
        font-weight: 600;
        line-height: 21px;
      }

      strong {
        color: #F58220;
      }
    }

    .best-option {
      height: fit-content;
      margin-left: 35px;
      background-color: #F58220;
      padding: 5px 6px;
      border-radius: 5px;
      color: #fff;
      font-weight: 500;
      width: fit-content;
    }
  }

  .checked {
    background-color: #005FAE;
    div {
      color: #fff;
    }
  }
`;